// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';
import { getModifiedBy } from '../../../utils/cells';

export default class CryptoCoinsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'cryptoCoins';
        this.Server = this.props.context.getState().server.cryptoCoins;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['friendlyName', 'chain', 'coin'];
        this.exportButton = true;

        const defaultHead = [
            {
                id: 'friendlyName',
                label: 'friendlyName',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'chain',
                label: 'chain',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'chainScannerLink',
                label: 'chainScannerLink',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'coin',
                label: 'coin',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'tokenContractAddress',
                label: 'tokenContractAddress',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'modifiedReason',
                label: 'modifiedReason',
                alignRight: false,
                cell: 'BigText',
                displayGrid: true,
                disableEditor: true,
                extraRender: (value, row) => getModifiedBy(row)
            },
            {
                id: 'dateCreatedModified',
                elements: ['dateCreated', 'dateModified'],
                label: 'dateCreatedModified',
                alignRight: false,
                cell: 'CreateModify',
                disableEditor: true,
                displayGrid: true,
                customSort: 'dateCreated'
            }
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
